import React from "react";
import { CreditCard, Smartphone, Wallet, Landmark, Check, Clock, Bitcoin, Coins } from "lucide-react";

// Selectable payment methods.
// "enabled: true"  -> processed through Stripe Checkout (real payments, test keys configured).
// "enabled: false" -> shown as "Bientôt disponible" until a PSP / bank aggregator is connected.
export const PAYMENT_METHODS = [
  { key: "card", label: "Visa / Mastercard", icon: CreditCard, enabled: true },
  { key: "applepay", label: "Apple Pay", icon: Smartphone, enabled: true },
  { key: "googlepay", label: "Google Pay", icon: Smartphone, enabled: true },
  { key: "paypal", label: "PayPal", icon: Wallet, enabled: false, badge: "Bientôt" },
  { key: "crypto", label: "Crypto (BTC / ETH)", icon: Bitcoin, enabled: false, badge: "Bientôt" },
  { key: "usdc", label: "Stablecoin (USDC)", icon: Coins, enabled: false, badge: "Bientôt" },
  { key: "pixpay", label: "Pix", icon: CreditCard, enabled: false, badge: "Bientôt" },
  { key: "mia", label: "MIA (Moldavie)", icon: Landmark, enabled: false, badge: "Bientôt" },
  { key: "mir", label: "Mir (Russie)", icon: CreditCard, enabled: false, badge: "Bientôt" },
];

export const PaymentMethods = ({ value, onChange, className = "" }) => (
  <div className={`grid grid-cols-2 gap-2 ${className}`} data-testid="payment-methods">
    {PAYMENT_METHODS.map((m) => {
      const Icon = m.icon;
      const selected = value === m.key;
      const disabled = !m.enabled;
      return (
        <button
          type="button"
          key={m.key}
          disabled={disabled}
          aria-disabled={disabled}
          title={disabled ? "Bientôt disponible — en attente d'activation du prestataire de paiement" : undefined}
          onClick={() => !disabled && onChange?.(m.key)}
          data-testid={`payment-method-${m.key}`}
          className={`relative flex items-center gap-2 rounded-xl border px-3 py-2.5 text-xs font-medium transition-colors ${
            disabled
              ? "border-border bg-muted/40 text-muted-foreground opacity-60 cursor-not-allowed"
              : selected
              ? "border-primary bg-primary/5 text-primary"
              : "border-border bg-card hover:border-primary/50"
          }`}
        >
          <Icon className="h-4 w-4 shrink-0" />
          <span className="truncate">{m.label}</span>
          {disabled && m.badge && (
            <span className="ml-auto inline-flex items-center gap-1 rounded-full bg-secondary px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-wide text-muted-foreground">
              <Clock className="h-2.5 w-2.5" /> {m.badge}
            </span>
          )}
          {!disabled && selected && <Check className="h-3.5 w-3.5 ml-auto text-primary" />}
        </button>
      );
    })}
  </div>
);

export default PaymentMethods;
